import React, { memo } from "react";
import { Persona } from "investira.react.components";
import { useSelector } from "react-redux";

/**
 * Renderiza o componente EntidadeAvatar.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {string} props.alt - Propriedade `alt` do componente.
 * @param {string} props.entidadeId - Identificador usado pelo componente.
 * @param {*} props.sizeLetters - Propriedade `sizeLetters` do componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const EntidadeAvatar = memo((props) => {
  const TIMESTAMP = new Date().getTime();
  const LOGO_HOST_URL = useSelector((store) => store.info.logo);

  const { alt, entidadeId, sizeLetters = 2 } = props;

  let xImageSrc = "";

  if (entidadeId) {
    const xLogoFolder = String(entidadeId).padStart(32, 0);
    xImageSrc = `${LOGO_HOST_URL}/${xLogoFolder}/lg@3x.png?${TIMESTAMP}`;
  }

  return (
    <Persona
      alt={alt}
      src={xImageSrc}
      sx={{ borderRadius: 2, ...props.sx }}
      sizeLetters={sizeLetters}
    />
  );
});

EntidadeAvatar.displayName = "EntidadeAvatar";

export default EntidadeAvatar;
